export enum CardPaymentEnum {
  GiftCard = 'Gift Card',
  Prepaid = 'Prepaid',
  Loyalty = 'Loyalty',
  Discount = 'Discount',
}
